
import { Subscription } from "@/models/subscription";
import Vue from "vue";
import AppSelectTier from "./SelectTier.vue";
import AppModuleSelectModal from "@/components/ModuleSelectModal.vue";
import { MODULE } from "@/config/modules";
import { PlanModule } from "@/models/plan-module";
import AppCompanyEditSubscriptionModuleMetaData from "./CompanyEditSubscriptionModuleMetaData.vue";
import {ISelectItem} from "winfakt-vue-components";
import {PaymentFrequency} from "@/models/plan";

export default Vue.extend({
	data(){
		return {
			selectModuleOpen: false,
			toEditModuleWithMetaData: null as PlanModule | null
		};
	},
	props: {
		sub: {
			type: Object as ()=>Subscription,
			required: true
		}
	},
	computed: {
		ignoredModules():MODULE[] {
			return this.sub.plan.modules.map(m=>m.ModuleID);
		},
		paymentFrequencyItems():ISelectItem<PaymentFrequency>[]{
			return [
				{
					text: "Maandelijks",
					value: PaymentFrequency.Monthly
				},
				{
					text: "Kwartaal",
					value: PaymentFrequency.Quarter
				},
				{
					text: "Jaarlijks",
					value: PaymentFrequency.Yearly
				},
				{
					text: "Permanent",
					value: PaymentFrequency.Permanent
				}
			];
		},
	},
	methods: {
		onRawClicked(){
			this.sub.rawMetadata = JSON.stringify(this.sub.plan.getJson());
			this.$emit("raw");
		},
		addModules(modules:MODULE[]){
			this.sub.plan.modules.push(...modules.map(m=>new PlanModule({ModuleID: m})));
		},
		removeModule(index:number){
			this.sub.plan.modules.splice(index,1);
		},
		editMetadata(mod:PlanModule){
			this.toEditModuleWithMetaData = mod;
		}
	},
	components: {
		AppSelectTier,
		AppModuleSelectModal,
		AppCompanyEditSubscriptionModuleMetaData
	}
});
